import React from "react";
import styled, { css } from "styled-components";
import { Box } from "src/components/Box";
import { useComboBoxContext } from "src/components/ComboBox/ComboBox.context";

export type IComboBoxOptionProps = {
  value?: string;
  label: string;
  readOnly?: boolean;
};

const WrapperEl = styled(Box)<Partial<IComboBoxOptionProps>>`
  align-items: center;
  display: flex;

  ${(p) => css`
    max-height: ${p.theme.components.combobox.optionHeight}px;
    min-height: ${p.theme.components.combobox.optionHeight}px;
    padding: 0 ${p.theme.dimension.spacing.l}px;
  `}

  ${(p) =>
    !p.readOnly &&
    css`
      cursor: pointer;
      :hover {
        background-color: rgba(10, 20, 30, 0.05);
      }
    `}
`;

const TextWrapperEl = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ComboBoxOption = (props: IComboBoxOptionProps) => {
  const { onSelect } = useComboBoxContext();

  const { value = "", label, readOnly } = props;

  const _onClick = () => {
    if (readOnly) {
      return;
    }
    onSelect({ value, label });
  };

  return (
    <WrapperEl
      className="asp-combobox--option"
      onClick={_onClick}
      readOnly={readOnly}
    >
      <TextWrapperEl>{label}</TextWrapperEl>
    </WrapperEl>
  );
};
